<div class="ax-panel">
  <app-grid name="Global Factor Performance Attribution Factor Security"
            [height]="500"
            (cellButtonClicked)="cellButtonClickHandler($event)"
            (onCellDrag)="cellDragHandler($event)">
  </app-grid>
</div>
